// routing
import Routes from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import ThemeCustomization from 'themes';
import { TeacherContextProvider } from './contexts/TeacherContext';
import { ContractsProvider } from 'contexts/ContractsContext';
import { AssessmentsProvider } from 'contexts/AssessmentsContext';

// auth provider
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import CalendarProvider from './contexts/CalendarContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP ||============================== //

const App = () => (
    <ThemeCustomization>
        {/* RTL layout */}
        <RTLLayout>
            <Locales>
                <NavigationScroll>
                    <AuthProvider>
                        <>
                            <ContractsProvider>
                                <AssessmentsProvider>
                                    <CalendarProvider>
                                        <TeacherContextProvider>
                                            <Routes />
                                        </TeacherContextProvider>
                                    </CalendarProvider>
                                </AssessmentsProvider>
                            </ContractsProvider>
                            <Snackbar />
                        </>
                    </AuthProvider>
                </NavigationScroll>
            </Locales>
        </RTLLayout>
    </ThemeCustomization>
);

export default App;
